<div class="chip-list">
  <div class="chip-list-wrapper">
    <ul class="chip-list-container pb-1">
      <li *ngFor="let chip of chips"
          [matTooltip]="getChipTooltip(chip)"
          class="chip chip_filters ml-3 d-inline-block">
        {{getChipContent(chip)}}
        <mat-icon class="chip_filters-icon" (click)="clearFilter(chip)">cancel</mat-icon>
      </li>
    </ul>
  </div>

  <div class="clear-button-wrap">
    <button (click)="clearFilters()"
            *ngIf="showClearButton"
            [attr.data-test-id]="'clearFiltersBtn'"
            [disabled]="isLoading"
            class="chip chip_round"
            mat-ripple>
      Очистити усе
    </button>
  </div>
</div>
